// Module
var code = `<div class="order-edit-parameter-sector">
    <terceraLabel text="{{prTypeLabel}}" />

    <terceraComboBox showLastValue="true"
                     items="{{dp.objectVariants}}"
                     selectedItem="{{dp.selectedValue}}" />
</div>

<div class="order-edit-parameter-sector modify-quantity">
    <terceraLabel text="{{mqLabel}}" />

    <div class-js-sltp-numeric="1" class-tr-stop-visible={{trStopVisible}}>

        <terceraNumeric tradingNumeric="true"
                        value="{{dp.value}}"
                        minValue="{{dp.minimalValue}}"
                        maxValue="{{dp.maximalValue}}"
                        step="{{dp.increment}}"
                        decimalPrecision="{{dp.decimalPlaces}}"
                        enabled="{{dp.enabled}}"
                        focused="{{focused}}"
                        hasError="{{dp.hasError}}"
                        errorText="{{errorText}}"
                        customErrorText="{{customErrorText}}"
                        customError={{dp.customError}}
                        validationStateInfo="{{validationStateInfo}}"
                        valueLessMinLocalKey={{valueLessMinLocalKey}}
                        valueGreaterMaxLocalKey={{valueGreaterMaxLocalKey}}
                        on-TerceraNumericClicked="terceraNumericInputClick"
                        name="MQNumeric" />

        <terceraCheckBoxButton checked="{{dp.enabled}}" text="MQ" tooltip="{{.tooltip}}" />
    </div>
</div>`;
// Exports
export default code;